import type { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { Game } from '@/types/games';
import type { GameViewModel } from '@/types/games/game-view-model';
import { adaptGame, adaptGames, type AdaptGameOptions } from '@/logic/game-adapter/adapt-game';
import type { ClientGameContext } from './client-game-context';

type ClientAdaptOptions = Omit<AdaptGameOptions, 'region' | 'isMobile'>;

export const toGameViewModel = (game: Game, ctx: ClientGameContext, options?: ClientAdaptOptions): GameViewModel =>
    adaptGame(game, { ...ctx, ...options });

export const toGameViewModels = (
    games: Game[],
    ctx: ClientGameContext,
    gridLayout?: PRISMIC_ZONE_LAYOUT,
    options?: ClientAdaptOptions
): GameViewModel[] => adaptGames(games, gridLayout, { ...ctx, ...options });
